import ReasonModal from './ReasonModal';

type Props = {
  onSubmit: (reason: string) => Promise<void>;
  onClose: () => void;
};

const PauseJourneysModal = ({ onSubmit, onClose }: Props) => (
  <ReasonModal
    body="Journey messages and call tasks stop, and open call tasks close. Shift and pay messages still go."
    confirmLabel="Pause journeys"
    failureMessage="Could not pause journeys."
    title="Pause journeys?"
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

export default PauseJourneysModal;
